import { call, put } from "redux-saga/effects";
import { toast } from "react-toastify";
import { api } from "../../Config/ApiInterface";
import { addorderFailure, addorderSuccess, deleteorderFailure, deleteorderSuccess, getorderFailure, getorderSuccess, updateorderFailure, updateorderSuccess } from "../../Actions";

// GET orders
function* getOrderListSaga(action) {
  try {
    const payload = action.payload || {};
    const { order_id, ...filters } = payload;
    const hotel_id = localStorage.getItem('hotel_id');
    
    // Build query parameters
    const queryParams = new URLSearchParams();
    queryParams.append('hotel_id', hotel_id);
    
    // Add order_id if present
    if (order_id) {
      queryParams.append('order_id', order_id);
    }
    
    // Add all other filter parameters
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== "") {
        queryParams.append(key, filters[key]);
      }
    });
    
    const url = `/orders-list?${queryParams.toString()}`;

    // Try with query parameters first, if that doesn't work, we can send data in body
    const response = yield call(api.post, url);
    if (response) {
      yield put(getorderSuccess(response.data));
    } else {
      yield put(getorderFailure(response.error || "Failed to fetch orders."));
    }
    toast.success(response.message);
  } catch (error) {
    yield put(getorderFailure(error));
    // toast.error("Failed to fetch orders.");
  }
}

//add room type
function* addOrderSaga(action) {
  try {
    // const {body} = action.payload
    const response = yield call(api.post, `/orders`,action.payload);
    if (response) {
      yield put(addorderSuccess(response.data));
      toast.success(response.data.message|| response.message);
    } else {
      yield put(addorderFailure(response.error || "Failed to add order."));
    }
  } catch (error) {
    yield put(addorderFailure(error));
    toast.error("Failed to add order.");
  }
}

//delete room type
function* deleteOrderSaga(action) {
  try {
    const { id } = action.payload;

    const response = yield call(api.delete, `/orders/${id}`);
    if (response) {
      yield put(deleteorderSuccess(response.data));
    } else {
      yield put(deleteorderFailure(response.error || "Failed to delete ordere."));
    }
    toast.success(response.message);
  } catch (error) {
    yield put(deleteorderFailure(error));
    toast.error("Failed to delete order.");
  }
}

function* putOrderSaga(action) {
  try {
    const { id, data } = action.payload;
    const response = yield call(api.put, `/orders/${id}`, data);
    if (response) {
      yield put(updateorderSuccess(response.data));
      toast.success(response.data.message|| response.message);
    } else {
      yield put(updateorderFailure(response.error || "Failed to update order."));
    }

  } catch (error) {
    yield put(updateorderFailure(error));
    toast.error("Failed to update order.");
  }
}


function* cancelledOrderSaga(action) {
  try {
    const { id, data } = action.payload;
    const response = yield call(api.patch, `/cancel/${id}`, data);
    if (response) {
      yield put(updateorderSuccess(response.data));
      toast.success(response.data.message|| response.message);
    } else {
      yield put(updateorderFailure(response.error || "Failed to cancelled order."));
    }
  } catch (error) {
    yield put(updateorderFailure(error));
    toast.error("Failed to cancelled order.");
  }
}

export { putOrderSaga, deleteOrderSaga, getOrderListSaga, addOrderSaga ,cancelledOrderSaga}
